export enum ResponsesListItemType {
  RequestResponse = 'request_response',
  ArtificialProposalResponse = 'artificial_proposal_response',
}
